/*
 * @Author: LiuLiXue QQ:136890965 
 * @Date: 2017-12-28 09:41:19 
 * @Last Modified by: LiuLiXue
 * @Last Modified time: 2018-01-23 14:14:02
 */
//转化为树形图结构的数据

export const toTreeData = (data,checked = []) => {
  if (!Object.prototype.toString.call(data) == '[object Array]') {
    console.warn('data must be Array!')
  }
  let len = data.length, checkedLen = checked.length;
  for (let i = 0; i < len; i++) {
    let id = data[i].id;
    for(let c = 0; c<checkedLen;c++) {
      if(id == checked[c]) {
        data[i]['disabled'] = true
      }
    }
  }
  let pos = {},
    tree = [],
    i = 0;
  while (0 != data.length) {
    if (0 === data[i].parentId) {
      if (1 === data[i].id) {
        tree.push({
          parentId: data[i].parentId,
          id: data[i].id,
          name: data[i].name,
          menuType: data[i].menuType,
          children: [],
          disabled: true
        });
      } else {
        tree.push({
          parentId: data[i].parentId,
          id: data[i].id,
          name: data[i].name,
          menuType: data[i].menuType,
          children: [],
          disabled: data[i].disabled
        });
      }
      pos[data[i].id] = [tree.length - 1];
      data.splice(i, 1);
      i--;
    } else {
      let posArr = pos[data[i].parentId];
      if (posArr != undefined) {
        let obj = tree[posArr[0]];
        for (let j = 1; j < posArr.length; j++) {
          obj = obj.children[posArr[j]];
        }
        obj.children.push({
          parentId: data[i].parentId,
          id: data[i].id,
          name: data[i].name,
          menuType: data[i].menuType,
          children: [],
          disabled: data[i].disabled
        });
        pos[data[i].id] = posArr.concat([obj.children.length - 1]);
        data.splice(i, 1);
        i--;
      }
    }
    i++;
    if (i > data.length - 1) {
      i = 0;
    }
  }
  return tree;
}


// WEBPACK FOOTER //
// ./src/pages/permissions/toTreeData.js